import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminHomeBanners = async (params = {}) => {
  if (!params.languageCode) params.languageCode = 'vi';
  const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.HOME_BANNERS.GET_ALL, { params });
  return response.data;
};

export const getAdminHomeBannerById = async (id) => {
  const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.HOME_BANNERS.GET_BY_ID(id));
  return response.data;
};

export const createHomeBanner = async (data) => {
  const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.HOME_BANNERS.CREATE, data);
  return response.data;
};

export const updateHomeBanner = async (id, data) => {
  const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.HOME_BANNERS.UPDATE(id), data);
  return response.data;
};

export const deleteHomeBanner = async (id) => {
  const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.HOME_BANNERS.DELETE(id));
  return response.data;
};
